/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * Toolbar 요소 통합 인덱스를 정의한다.
 *
 * @file /src/namespaces/components/Taskbar.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 1. 30.
 */
import { Taskbar as TaskbarBase } from '@components/taskbar/Taskbar';
import { Task as TaskBase } from '@components/taskbar/elements/Task';

export class Taskbar extends TaskbarBase {}
export namespace Taskbar {
    export const Task = TaskBase;
}
